export default __webpack_public_path__ + "static/img-kortical-timeline-24b7abea43fdc0a26321e7d574a3146d.png";